export default "__VITE_ASSET__FsSTy97E__"